import React from 'react';
import './GlobalLoader.css';

const GlobalLoader = ({ 
  title = "Loading...", 
  
  show = true,
  fullScreen = true 
}) => {
  if (!show) return null;

  return (
    <div className={`global-loader ${fullScreen ? 'global-loader-fullscreen' : ''}`}>
      <div className="global-loader-content">
        <div className="global-loader-animation">
          <div className="global-loader-spinner"></div>
        </div>
      
      </div>
    </div>
  );
};

export default GlobalLoader;
